import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { setCssProperty } from '../../../../cross-team-shared/misc-utils';
import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { AbstractSensorContentStore2D } from '../../state/abstract-sensor-content-store-2d';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- svg needs attribute selectors
  selector: '[h3SvgText]',
  templateUrl: './svg-text.component.html',
  styleUrls: ['./svg-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SvgTextComponent extends DirectiveSuperclass implements OnInit {
  @Input('h3SvgText') text!: string;
  @Input({ required: true }) scale$!: Observable<number>;
  @Input({ required: true }) location!: Point2D;
  strokeWidth$!: Observable<number>;

  private store = inject(AbstractSensorContentStore2D);
  private elementRef = inject(ElementRef<SVGElement>);

  ngOnInit() {
    const fontSize$ = combineLatest([
      this.scale$,
      this.store('pixelSize').$,
    ]).pipe(map(([scale, pixelSize]) => Math.max(10 / scale, pixelSize)));
    this.subscribeTo(fontSize$, (size) => {
      setCssProperty(this.elementRef, 'font-size', size + 'px');
    });
    this.strokeWidth$ = fontSize$.pipe(map((size) => size / 2));
  }
}
